<dt-modal-content (closeClick)="close()">
  <ng-template #title>
    @if (data.category) {
      <ng-container i18n>Kategorie bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Kategorie hinzufügen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <mat-form-field>
        <mat-label i18n>Name</mat-label>
        <input matInput type="text" formControlName="name" />
        @if (formGroup.controls.name.errors?.['already-exists']) {
          <mat-error i18n>Der Name ist schon vergeben</mat-error>
        }
      </mat-form-field>

      @if (data.category) {
        <div class="category-id">
          <span i18n>Themengebiet-ID: &nbsp;</span><span class="grey">{{ data.category.id }}</span>
          <button
            mat-icon-button
            type="button"
            [cdkCopyToClipboard]="data.category.id"
            matTooltip="Themengebiet-ID kopieren"
            i18n-matTooltip
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      }

      <div class="button-wrapper">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [dtOverlayProgress]="formGroup.disabled"
          [disabled]="formGroup.disabled || formGroup.invalid"
          i18n
          >Speichern</button
        >
        <button mat-stroked-button type="reset" [disabled]="formGroup.disabled" (click)="close()" i18n>Verwerfen</button>
        @if (data.category) {
          <button mat-stroked-button type="button" color="warn" [disabled]="formGroup.disabled" (click)="delete()" i18n
            >Kategorie löschen</button
          >
        }
      </div>
    </form>
  </ng-template>
</dt-modal-content>
